import { Controller } from "stimulus"

export default class extends Controller { 
  update(text, targetElement) {
    let _targetElement = targetElement || this.element;
    _targetElement.innerText = text;
  }
}
